import { DatePicker } from "@mui/x-date-pickers";
import { Moment } from "moment";
import { FC, useRef, useState } from "react";

type Props = {
	value: Moment;
	onChange: (date: Moment | null) => void;
	minDate?: Moment;
	maxDate?: Moment;
	onOpen?: () => void;
	onClose?: () => void;
};

export const StartFilter: FC<Props> = ({
	value,
	onChange,
	minDate,
	maxDate,
	onOpen,
	onClose,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const pendingValue = useRef<Moment | null>(null);

	return (
		<DatePicker
			label="Start"
			format="MM/DD/YYYY"
			value={value}
			minDate={minDate}
			maxDate={maxDate}
			onOpen={() => {
				setIsOpen(true);
				onOpen?.();
			}}
			onClose={() => {
				setIsOpen(false);
				if (pendingValue.current !== null) {
					const val = pendingValue.current;
					pendingValue.current = null;
					setTimeout(() => onChange(val), 50);
				}
				onClose?.();
			}}
			onChange={(newValue) => {
				if (isOpen) {
					pendingValue.current = newValue;
				} else {
					onChange(newValue);
				}
			}}
			slotProps={{
				textField: { size: "small" },
			}}
		/>
	);
};

export const EndFilter: FC<Props> = ({
	value,
	onChange,
	minDate,
	maxDate,
	onOpen,
	onClose,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const pendingValue = useRef<Moment | null>(null);

	return (
		<DatePicker
			label="End"
			format="MM/DD/YYYY"
			value={value}
			minDate={minDate}
			maxDate={maxDate}
			onOpen={() => {
				setIsOpen(true);
				onOpen?.();
			}}
			onClose={() => {
				setIsOpen(false);
				if (pendingValue.current !== null) {
					const val = pendingValue.current;
					pendingValue.current = null;
					setTimeout(() => onChange(val), 50);
				}
				onClose?.();
			}}
			onChange={(newValue) => {
				if (isOpen) {
					pendingValue.current = newValue;
				} else {
					onChange(newValue);
				}
			}}
			slotProps={{
				textField: { size: "small" },
			}}
		/>
	);
};
